export const mineralInitialState = {
    mineral: null,
    isLoading: true
}